"use strict";

import * as Video from "components/Video";
document.addEventListener("DOMContentLoaded", function () {
  Video.init();
});
window.addEventListener("load", function () {});
